import { type InputHTMLAttributes, type Ref } from 'react';
import styled from 'styled-components';

import Box from 'components/styled/Box';

const SIZES = {
  SMALL: 'small',
  MEDIUM: 'medium',
  LARGE: 'large',
} as const;

const getHeight = ({ size }: any) => {
  switch (size) {
    case SIZES.SMALL:
      return '30px';
    case SIZES.LARGE:
      return '60px';
    case SIZES.MEDIUM:
    default:
      return '40px';
  }
};

const StyledInput = styled(Box)<{ $fullWidth?: boolean }>`
  display: block;
  width: 100%;
  padding: 0 0.5em;
  height: 2.5em;
  border-radius: 2px;
  border: 1px solid ${({ theme }) => theme.colors.border.contrast};

  &[type='checkbox'],
  &[type='radio'] {
    display: inline-block;
    width: auto;
    height: auto;
    padding: 0;
  }

  &::placeholder {
    color: currentcolor;
    opacity: 0.5;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  textarea & {
    padding: 0.5em;
    height: auto;
  }

  height: ${getHeight};
  width: ${({ $fullWidth }) => $fullWidth && '100%'};
  color: ${({ theme }) => theme.colors.text.primary};
  background-color: ${({ theme }) => theme.colors.background.alt2};
`;

type InputProps = InputHTMLAttributes<HTMLInputElement> & {
  fullWidth?: boolean;
  size?: 'small' | 'medium' | 'large';
  'data-test-id'?: string;
  ref?: Ref<HTMLInputElement>;
};

export default ({ fullWidth, ref, ...props }: InputProps) => (
  <StyledInput {...props} ref={ref} as="input" type={props.type || 'text'} $fullWidth={fullWidth} />
);
